import { useEffect, useState } from 'react';

import {
  getPrefersHoverDesktop,
  HOVER_DESKTOP_MEDIA_QUERY,
} from '../constants/layoutBreakpoints';

const usePrefersHoverDesktop = (): boolean => {
  const [prefersHoverDesktop, setPrefersHoverDesktop] = useState(getPrefersHoverDesktop);

  useEffect(() => {
    const mediaQuery = window.matchMedia(HOVER_DESKTOP_MEDIA_QUERY);
    const handleChange = () => setPrefersHoverDesktop(mediaQuery.matches);

    handleChange();
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return prefersHoverDesktop;
};

export default usePrefersHoverDesktop;
